import * as React from 'react'
import { connect } from 'react-redux'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Button } from '@amzn/dvui/dist/Button'
import { ActionForm } from '../../utils/actionForm'
import { StringId } from '../localizer/stringId'
import { TextLocalizer } from '../localizer/localizer'
import { clearWatchlistFailure, toggleWatchlist } from '../../actions/watchlist'
import { WatchlistToggleInput } from 'DVWebNodeUtils'
import { IDetailPageState } from '../../reducers'
import { watchlistComponentSelector } from '../../selectors/component/watchlistComponentSelectors'
import { SpinnerWithDelay } from '../spinners/spinnerWithDelay'
import { ModalTrigger, ModalRenderPropArgs } from '../../utils/ModalTrigger'
import * as st from './watchlist.module.scss'
import { acknowledgeEvent } from '../../utils/utils'
import * as cn from 'classnames'
import * as utilityClasses from '../utilityClasses.module.scss'

// TODO: AVWebDetailPage-1781

const TAG_REMOVE = 'Remove'

export interface IWatchlistProps {
  partialURL: string
  query: WatchlistToggleInput
  tag: WpsRuntime.atv.wps.WatchlistActionTag
  text: WpsRuntime.atv.wps.DVString
  ajaxEnabled: boolean
  isSeason: boolean
  failed: boolean
}

type StateProps = {
  watchlist?: IWatchlistProps
  pageTitleId: string
}

type LocalState = {
  disabled: boolean
  isLoading: boolean
}

type ExtraProps = {
  isHover: boolean
}

type ConnectedWatchlistProps = StateProps & ExtraProps
export class ConnectedWatchlist extends React.Component<
  ConnectedWatchlistProps,
  LocalState
> {
  state = {
    disabled: false,
    isLoading: false,
  }

  clickHandler = (e: React.MouseEvent<HTMLElement>) => {
    acknowledgeEvent(e)
    this.setState({
      disabled: true,
      isLoading: true,
    })
    toggleWatchlist(this.props.watchlist!.query, this.props.pageTitleId)
    e.preventDefault()
  }

  componentDidUpdate(prevProps: ConnectedWatchlistProps) {
    if (prevProps !== this.props) {
      this.setState({
        disabled: false,
        isLoading: false,
      })
    }
  }

  render() {
    const { watchlist, isHover } = this.props

    if (!watchlist) {
      return null
    }

    // ajaxEnabled is false for unrecognized users: https://code.amazon.com/packages/ATVWebPresentationScala/blobs/invoices/--/src/atv/web/presentation/WatchlistAction.scala#L128
    const { partialURL, query, tag, ajaxEnabled, isSeason, failed } = watchlist

    const isOnWatchlist = tag === TAG_REMOVE

    const addStringsId = isSeason
      ? StringId.DV_DP_WL_addTv
      : StringId.DV_DP_WL_addMovie
    const addedStringsId = isSeason
      ? StringId.DV_DP_WL_removeTv
      : StringId.DV_DP_WL_removeMovie
    const toggleStringId = (isOnWatchlist ? addedStringsId : addStringsId)

    const buttonStyling = cn(
      st.button,
      { [st.hoverButton]: isHover },
    )

    // TODO: Add refTag : AVWebDetailPage-1782
    // Legacy: add pageType/subPageType to hiddenInputs
    // utility to call gp/video/ajax/analytics.html/ref=<ref_tag>

    return (
      <span className="avu-full-width-phablet dv-dp-node-watchlist">
        <ActionForm
          action={partialURL}
          method="POST"
          hiddenInputs={query as { [key: string]: string }}
        >
          <Button
            disabled={this.state.disabled}
            className={buttonStyling}
            onClick={ajaxEnabled ? this.clickHandler : undefined}
            forceDoubleHeight={!isHover}
            data-ux-click
            type="submit"
            data-added={isOnWatchlist}
          >
            <SpinnerWithDelay isLoading={this.state.isLoading}>
              <TextLocalizer stringID={toggleStringId} />
            </SpinnerWithDelay>
          </Button>
        </ActionForm>

        <ModalTrigger
          modalId='dvui-close-overlay-watchlist-failed'
          isOpen={failed}
          modalHeader={<TextLocalizer stringID={toggleStringId} />}
          modalContent={<TextLocalizer stringID={StringId.AVOD_WL_error_msg} />}
          modalFooter={
            ({ closeModal }: ModalRenderPropArgs) => {
              return (
                <Button className={utilityClasses.alwaysInline} onClick={() => closeModal()} >
                  <TextLocalizer stringID={StringId.AVOD_DP_E_error_ok} />
                </Button>
              )
            }
          }
          onClose={() => clearWatchlistFailure(this.props.pageTitleId)} />
      </span>
    )
  }
}

const mapStateToProps = (state: IDetailPageState): StateProps => {
  return {
    watchlist: watchlistComponentSelector(state),
    pageTitleId: state.pageTitleId,
  }
}

export const Watchlist = connect(mapStateToProps)(ConnectedWatchlist)
